import { UserDetailsListResponse, TenantListResponse, UserDetails } from '../infrastructure/models';
import ApiService from "./ApiService";

export const fetchUsersByTenant = async (tenantId: string, offset = 0, limit = 10, signal?: AbortSignal): Promise<UserDetailsListResponse> => {
    const response = await ApiService.get<UserDetailsListResponse>({ url: `Admin/tenants/${tenantId}/users?offset=${offset}&limit=${limit}`, signal });
    return response;
}

export const fetchAllTenants = async (offset = 0, limit = 10, signal?: AbortSignal): Promise<{ data: any[]; total: number; offset: number; limit: number }> => {
    const response = await ApiService.get<TenantListResponse>({ url: `Admin/tenants?offset=${offset}&limit=${limit}`, signal });
    return response;
}

export const grantAdminAccess = async (userId: string, signal?: AbortSignal): Promise<UserDetails> => {
    const response = await ApiService.post<UserDetails>({ url: `Admin/users/${userId}/grant-admin`, signal });
    return response;
}

export const revokeAdminAccess = async (userId: string, signal?: AbortSignal): Promise<UserDetails> => {
    const response = await ApiService.post<UserDetails>({ url: `Admin/users/${userId}/revoke-admin`, signal });
    return response;
}

export const deactivateUser = async (tenantId: string, userId: string, signal?: AbortSignal) => {
    await ApiService.delete({ url: `Admin/tenants/${tenantId}/users/${userId}`, signal });
}

export const fetchAvailableUserPerTenant = async (tenantId: string, signal?: AbortSignal): Promise<UserDetails[]> => {
    const response = await ApiService.get<UserDetails[]>({ url: `Admin/tenants/${tenantId}/users/available`, signal });
    return response;
}

export async function addUserToTenant(tenantId: string, userIds: string[], signal?: AbortSignal): Promise<void> {
    await ApiService.post({ url: `Admin/tenants/${tenantId}/users/bulk`, data: { userIds : userIds }, signal });
}